import request from '@/utils/request';
import jsonRequest from '@/utils/jsonRequest';
var qs = require('qs');
// import qs from 'qs'

// export function initData(url, params) {
//   return request({
//     url: url + '?' + qs.stringify(params, { indices: false }),
//     method: 'get'
//   })
// }
export function sendLoginCode(data) {
  return request({
    url: '/merchant/login/sendLoginCode',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function doLogin(data) {
  return request({
    url: '/merchant/login/doLogin',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function doLogout() {
  return request({
    url: '/merchant/login/doLogout',
    method: 'post'
  })
}
export function getLoginQrImg() {
  return jsonRequest({
    url: '/merchant/login/getLoginQrImg',
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js